import { CheckCircle } from '@untitledui/icons'
import OptimizedImage from '@/components/OptimizedImage'
import Button from '@/components/Button'
import useTranslation from '@/hooks/useTranslation'

function CardIcon() {
    return (
        <svg
            width="27"
            height="20"
            viewBox="0 0 27 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M21.6992 18.7C23.0994 18.7 23.7994 18.7 24.3342 18.4197C24.8046 18.1731 25.1871 17.7798 25.4267 17.2959C25.6992 16.7459 25.6992 16.0258 25.6992 14.5857V4.81424C25.6992 3.3741 25.6992 2.65404 25.4267 2.10398C25.1871 1.62013 24.8046 1.22675 24.3342 0.980222C23.7994 0.699953 23.0994 0.699953 21.6992 0.699953L4.69922 0.699951C3.29909 0.699951 2.59902 0.699951 2.06424 0.98022C1.59384 1.22675 1.21139 1.62013 0.971703 2.10398C0.699219 2.65403 0.699219 3.3741 0.699219 4.81424L0.699219 14.5857C0.699219 16.0258 0.699219 16.7459 0.971702 17.2959C1.21139 17.7798 1.59384 18.1731 2.06424 18.4197C2.59902 18.6999 3.29909 18.6999 4.69922 18.6999L21.6992 18.7Z"
                fill="#000D1E"
            />
            <path
                d="M11.9492 12.2714H5.69922M0.699219 4.81424L0.699219 14.5857C0.699219 16.0258 0.699219 16.7459 0.971702 17.2959C1.21139 17.7798 1.59384 18.1731 2.06424 18.4197C2.59902 18.6999 3.29909 18.6999 4.69922 18.6999L21.6992 18.7C23.0994 18.7 23.7994 18.7 24.3342 18.4197C24.8046 18.1732 25.1871 17.7798 25.4267 17.2959C25.6992 16.7459 25.6992 16.0258 25.6992 14.5857V4.81424C25.6992 3.3741 25.6992 2.65404 25.4267 2.10398C25.1871 1.62013 24.8046 1.22675 24.3342 0.980222C23.7994 0.699953 23.0994 0.699953 21.6992 0.699953L4.69922 0.699951C3.29909 0.699951 2.59902 0.699951 2.06424 0.98022C1.59384 1.22675 1.21139 1.62013 0.971703 2.10398C0.699219 2.65403 0.699219 3.3741 0.699219 4.81424Z"
                stroke="white"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default function WarrantySuccess({ data, onAssociateMore }) {
    const { language, t } = useTranslation()
    const { collection, model, warrantyStartDate, imageUrl, cardCodes } = data

    const [y, m, d] = warrantyStartDate.split('-').map(Number)
    const formattedDate = new Intl.DateTimeFormat(language, {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    }).format(new Date(y, m - 1, d))

    return (
        <div className="flex flex-col items-center gap-[40px] max-w-[630px] mx-auto">
            {/* Header: icon + count */}
            <div className="flex flex-col items-center gap-[20px]">
                <CheckCircle size={40} color="#34C759" />
                <span className="text-[18px] font-semibold uppercase text-[#34C759]">
                    {t('warranty.cardsAssociated', { count: cardCodes.length })}
                </span>
            </div>

            {/* Content */}
            <div className="flex flex-col gap-[20px] w-full">
                {/* Product card */}
                <div className="flex border border-dark-blue/10 rounded-[12px] overflow-hidden">
                    <div className="flex items-center justify-center w-[120px] min-h-[158px] bg-background-product p-[20px] shrink-0">
                        {imageUrl ? (
                            <OptimizedImage
                                src={imageUrl}
                                alt={model}
                                sizes="80px"
                                className="w-[80px] h-[118px] object-contain"
                            />
                        ) : (
                            <div className="w-[80px] h-[118px] bg-dark-blue/5 rounded-[4px]" />
                        )}
                    </div>

                    <div className="flex flex-col justify-center gap-[12px] py-[20px] px-[20px]">
                        <span className="text-[16px] text-dark-blue/40">
                            {t('warranty.collection', { name: collection })}
                        </span>
                        <span className="text-[16px] text-dark-blue/40">
                            {t('warranty.model', { name: model })}
                        </span>
                        <span className="text-[16px] text-dark-blue/40">
                            {t('warranty.warrantyStartDate', { date: formattedDate })}
                        </span>
                    </div>
                </div>

                {/* Card codes */}
                <div className="flex flex-col gap-[12px] bg-background-product rounded-[12px] p-[20px] max-h-[200px] overflow-y-auto">
                    {cardCodes.map((code) => (
                        <div key={code} className="flex items-center gap-[8px]">
                            <CardIcon />
                            <span className="text-[14px] text-dark-blue">
                                {code}
                            </span>
                        </div>
                    ))}
                </div>

                {/* CTA */}
                <Button fullWidth onClick={onAssociateMore}>
                    {t('warranty.associateMoreCards')}
                </Button>
            </div>
        </div>
    )
}
